<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :router="{
      name: 'USERS_LIST',
    }"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      label-position="top"
      ref="ruleForm"
      label-width="120px"
      class="carpo-form demo-ruleForm"
    >
      <el-form-item :label="$t('USERNAME')" prop="username">
        <el-input
          :disabled="ruleForm.disabled"
          type="text"
          v-model="ruleForm.username"
          autocomplete="off"
          class="left-inputs"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="!user" :label="$t('PASSWORD')" prop="password1">
        <el-input
          type="password"
          v-model="ruleForm.password1"
          autocomplete="off"
          show-password
          class="left-inputs"
        ></el-input>
      </el-form-item>

      <el-form-item v-if="!user" :label="$t('CONFIRM_PASSWORD')" prop="password2">
        <el-input
          type="password"
          v-model="ruleForm.password2"
          autocomplete="off"
          show-password
          class="left-inputs"
        ></el-input>
      </el-form-item>

      <el-form-item
        v-if="!user"
        :label="$t('ORGANIZATION')"
        prop="organizations"
        v-loading="organizationsLoading"
        element-loading-spinner="el-icon-loading"
      >
        <el-select
          :disabled="ruleForm.disabled"
          v-model="ruleForm.organizations"
          clearable
          :collapse-tags="!ruleForm.disabled"
          filterable
          :placeholder="$t('SELECT_PLACEHOLDER')"
          multiple
        >
          <el-option
            v-for="item in organizationsList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <div
        class="
          lg:col-span-full
          mt-4
          lg:flex-row
          flex-col flex
          items-start
          gap-2
        "
      >
        <el-form-item
          :label="`${$t('policies')}`"
          prop="policies"
          v-loading="policyLoading"
          class="multiselect-el w-full flex-grow"
          element-loading-spinner="el-icon-loading"
        >
          <el-select
            :disabled="ruleForm.disabled"
            v-model="ruleForm.policies"
            clearable
            multiple
            filterable
            :placeholder="$t('SELECT_PLACEHOLDER')"
          >
            <el-option
              v-for="item in policies"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button @click="selectAllPolicies">
          {{ $t('SELECT_ALL') }}
        </el-button>
      </div>

      <FormConfirmation
        v-show="!ruleForm.disabled"
        @resetForm="resetForm('ruleForm')"
        @submitForm="submitForm('ruleForm')"
        :edit="null"
        :loading="submitLoading"
      />
    </el-form>
  </Content>
</template>

<script>
import { resetForm } from '@/mixins/resetForm'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import { addUser, editUser, getPolicies, organizationSummaryList } from '@/api/acl'

export default {
  mixins: [resetForm],
  props: ['user'],
  watch: {
    user(val) {
      this.ruleForm = val
    },
  },
  components: {
    FormConfirmation,
  },
  data() {
    const usernameValidator = (rule, value, callback) => {
      const validPattern = /^[a-z0-9@./+/-/_]*$/
      if (!value) {
        callback(
          new Error(
            this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('USERNAME'),
            })
          )
        )
      } else if (value.length > 150) {
        callback(new Error(this.$i18n.t('USERNAME_TOO_LONG')))
      } else if (!validPattern.test(value)) {
        callback(new Error(this.$i18n.t('INVALID_USERNAME')))
      } else {
        callback()
      }
    }

    const passwordValidator = (rule, value, callback) => {
      if (!value) {
        callback(
          new Error(
            this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('PASSWORD'),
            })
          )
        )
      } else if (value.length < 8) {
        callback(new Error(this.$i18n.t('PASSWORD_TOO_SHORT')))
      } else if (/^\d+$/.test(value)) {
        callback(new Error(this.$i18n.t('PASSWORD_ENTIRELY_NUMERIC')))
      } else {
        callback()
      }
    }

    const confirmPasswordValidator = (rule, value, callback) => {
      if (value !== this.ruleForm.password1) {
        callback(new Error(this.$i18n.t('PASSWORDS_DO_NOT_MATCH')))
      } else {
        callback()
      }
    }

    return {
      submitLoading: false,
      organizationsList: [],
      organizationsLoading: true,
      policies: [
        {
          label: '',
          value: '',
        },
      ],
      policyLoading: true,
      ruleForm: {
        username: '',
        policies: [],
        organizations: '',
        password1: '',
        password2: '',
      },

      rules: {
        username: [
          {
            required: true,
            validator: usernameValidator,
            trigger: 'blur',
          },
        ],
        organizations: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('ORGANIZATION'),
            }),
            trigger: 'change',
          },
        ],
        policies: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('policies'),
            }),
            trigger: 'change',
          },
        ],
        password1: [
          {
            required: true,
            validator: passwordValidator,
            trigger: 'blur',
          },
        ],
        password2: [
          {
            required: true,
            validator: confirmPasswordValidator,
            trigger: 'blur',
          },
        ],
      },
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            organizations: this.ruleForm.organizations,
            username: this.ruleForm.username,
            policies: this.ruleForm.policies,
            password1: this.ruleForm.password1,
            password2: this.ruleForm.password2,
            id: this.user != undefined ? this.user.id : '',
          }

          this.submitLoading = true

          var dispatchFunc =
            this.user == null ? addUser : editUser


            dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.$notify.success({
                title:
                  this.$t(this.$route.name) +
                  ' ' +
                  this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
              if (this.user == null) this.resetForm(formName)
              else
                this.$router.push({
                  name: 'USERS_LIST',
                })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
    selectAllPolicies() {
      this.ruleForm.policies = this.policies.map((item) => item.value)
    },
  },
  mounted() {
    getPolicies.api().then((res) => {
      if (res) {
        this.policies = res.map((i) => {
          return {
            value: i.id,
            label: this.$i18n.locale === 'fa' ? i.fa_title : i.en_title,
          }
        })

        this.policyLoading = false
      }
    })
    organizationSummaryList.api().then((res) => {
      if (res) {
        this.organizationsList = res.map((i) => {
          return {
            value: i.id,
            label: i.title,
          }
        })

        this.organizationsLoading = false
      }
    })
  },
}
</script>
